module.exports = __webpack_public_path__ + "static/img/b4.dd8b9f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/b4.png
// module id = R9bS
// module chunks = 0